import React from 'react';
import { motion } from 'framer-motion';

const SearchBar: React.FC = () => {
    return (
        <motion.div
            className="search-bar"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
        >
            <input type="text" placeholder="Search for a city, dates, guests..." />
            <button>🔍</button>
        </motion.div>
    );
};

export default SearchBar;
